import React from 'react';
import { ReactDataTableTitle } from '@metarouter-private/mr-mui';

const LABEL = 'Event Schema';

export default function EventSchemasTableTitle() {
  return <ReactDataTableTitle label={LABEL} />;
}
